import { render, staticRenderFns } from "./PageEventGameTutorial.vue?vue&type=template&id=65578212&"
import script from "./PageEventGameTutorial.vue?vue&type=script&lang=js&"
export * from "./PageEventGameTutorial.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGameTutorial.vue?vue&type=style&index=0&id=65578212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports